import React from "react";
import { useAuth } from "./context/AuthContext";

export function Login({ onAuthed, bootErr }: { onAuthed?: any; bootErr?: any }) {
  const { login } = useAuth();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [err, setErr] = React.useState<string>("");
  const [loading, setLoading] = React.useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      // Basic heuristic: if username doesn't have @, append a fake domain for demo purposes if needed, 
      // but usually we expect email for Firebase.
      let email = username.trim();
      // If user types 'kevin', we might need to know the real email. 
      // For now assume user types full email or we let it fail.
      // Or we can provide a hint.
      
      await login(email, password);
      // Success will trigger App.tsx re-render via AuthContext
    } catch (e: any) {
      console.error(e);
      setErr("登入失敗: " + (e.message || "請檢查帳號密碼"));
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h1 className="h1">LegalOps Platform</h1>
        <p className="p">請登入以進入系統 (Firebase Auth)。</p>

        <form onSubmit={handleLogin}>
          <div className="field">
            <div className="label">Email</div>
            <input 
              className="input" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              placeholder="user@example.com" 
            />
          </div>
          
          <div className="field">
            <div className="label">密碼 (Password)</div>
            <div style={{ position: "relative" }}>
              <input 
                className="input" 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                placeholder="••••••••" 
                style={{ paddingRight: 40 }} 
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "var(--muted)",
                  padding: 4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn"
            disabled={loading}
          >
            {loading ? "登入中..." : "登入 (Sign in)"}
          </button>
        </form>

        {err ? <div className="err">{err}</div> : null}

        {bootErr ? (
          <div className="booterr">
            <b>Captured runtime error</b>
            {"\n"}[{bootErr.type}] {bootErr.message}
          </div>
        ) : null}
      </div>
    </div>
  );
}